export default __webpack_public_path__ + "static/media/Sublime.ecc3be25.png";